/* eslint-disable max-len */
import React, { useContext, useEffect, useState, useRef } from "react";
import GlobalContext from "../../../../components/Context/GloablContext";
import { Link, useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { dataService } from "../../../../services/data.services";
import CardHeader from "../../../../components/CardHeader";
import BasicDetails from "./ViewStudentComponents/BasicDetails";
import ContactDetails from "./ViewStudentComponents/ContactDetails";
import AcademicDetails from "./ViewStudentComponents/AcademicDetails";
import AcademicReports from "./ViewStudentComponents/AcademicReports";
import AttendanceReports from "./ViewStudentComponents/AttendanceReports";
import Skeleton from "./Skeleton";
import StudentStatement from "./ViewStudentComponents/StudentStatement";
import Toast from "../../../../components/Toast";
import { GetBranchId } from "../../../../CommonMethods/GetBranchId";
import FutureTermsModel from "./ViewStudentComponents/FutureTermsModel";
import { useOnClickOutside } from '../../../../CommonMethods/OutsideClick';
import AnimatedButton from '../../../../components/Animation/AnimatedButton';
import AnimatedModel from '../../../../components/Animation/AnimatedModel';
import ConfirmationModel from '../../../../components/ConfirmationModel';
import ConfirmationPrompt from '../../../../components/ConfirmationPrompt';
import ParentInvitePopup from './ViewStudentComponents/ParentInvitePopup';

const ViewStudent = () => {
    const { isSideNavBar, isInactiveBranch, setToastmessage } = useContext(GlobalContext);
    const { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const [studentDetails, setStudentDetails] = useState({});
    const [studentInvoiceDetails, setStudentInvoiceDetails] =useState([])
    const [loading, setLoading] = useState(true);
    const [isParamsValid, setIsParamsValid] = useState(true)
    const [viewLoading, setViewLoading] = useState(true);
    const [searchParams, setSearchParams] = useSearchParams('')
    const [tabs, settabs] = useState(searchParams?.get('tab_name') !== null ? searchParams?.get('tab_name') : 'Basic');
    const [currentFinacialYear, setCurrentFinacialYear] = useState('')
    const [financialYearsDropdownOptions, setFinancialYearsDropdownOptions]=useState({})
    const [academicYearsDropdownOptions,setAcademicYearsDropdownOptions] =useState({})
    const [startDate, setStartDate] = useState('2023-04-01');
    const [endDate, setEndDate] = useState('2024-05-01');
    const [startDateDisplay, setStartDateDisplay] = useState(setStartDate);
    const [endDateDisplay, setEndDateDisplay] = useState(setEndDate);
    const [invoiceStatus, setInvoiceStatus] = useState('All')
    const [toastErrorMessage, setToastErrorMessage] = useState('')
    const [apiIsLoading, setApiIsLoading] = useState(false)
    const [isFutureTermsModel, setIsFutureTermsModel] = useState(false);
    const validDateRanges = ['Financial Year', 'Academic Year', 'Custom'];
    const validInvoiceStatuses = ['All', 'Invoices With Due', 'Paid'];
    const initialState = {
        tabArray: ["Basic", "Contact", "Academic", "Student Statement", "Attendance", "Academic Reports"],
        validTabNames: ['Basic', 'Contact', 'Academic', 'Student Statement', "Attendance", 'Academic Reports'],
    }
    
    const [tabArray, setTabArray] = useState(initialState?.tabArray);
    const [validTabNames, setValidTabNames] = useState(initialState?.validTabNames);
    const [dottedDropDown, setDottedDropDown] = useState(false);
    const [approveTriminate, setApproveTriminate] = useState(false)
    const [isOutstandingFee, setIsOutStandingFee] = useState(false)
    const threeDottedRef = useRef()
    useOnClickOutside(threeDottedRef, () => {
        setDottedDropDown(false)
    })
    const [studentDataToTerminate, setStudentDataToTerminate] = useState({
        studentName: '',
        studentRecordID: '',
        studentID:''
    })
    const [loadingButton, setLoadingButton] = useState(false)
    const [refreshKey, setRefreshKey] = useState(false);
    const [showParentInvitePopup, setShowParentInvitePopup] = useState(false)
    const [fatherInviteLoading, setFatherInviteLoading] = useState(false)
    const [motherInviteLoading, setMotherInviteLoading] = useState(false)

    
    /**
     * The function `isValidDateFormat` checks if a given date string is in the format YYYY-MM-DD.
     * @returns The function `isValidDateFormat` returns a boolean value indicating whether the
     * `dateString` parameter matches the format "YYYY-MM-DD".
     */
    const isValidDateFormat = (dateString) => {
        // Validate date format (YYYY-MM-DD)
        const dateFormatRegex = /^\d{4}-\d{2}-\d{2}$/;
        return dateFormatRegex.test(dateString);
    };

    /**
     * The function `validateParameters` checks if the given parameters are valid based on certain
     * conditions and returns true if they are valid, otherwise false.
     * @returns a boolean value. If all the parameters pass the validation logic, it will return true
     * indicating that the parameters are valid. Otherwise, it will return false indicating that the
     * parameters are invalid.
     */
    const validateParameters = (tabName, dateRange, invoiceStatus, startDate, endDate) => {
        if (tabName && !validTabNames.includes(tabName)) {
            console.log("Invalid tabName:", tabName);
            return false; // Invalid tabName
        }
        if (dateRange && !validDateRanges.includes(dateRange)) {
            console.log("Invalid dateRange:", dateRange);
            return false; // Invalid dateRange
        }
        if (invoiceStatus && !validInvoiceStatuses.includes(invoiceStatus)) {
            console.log("Invalid invoiceStatus:", invoiceStatus);
            return false; // Invalid invoiceStatus
        }
        if (startDate && !isValidDateFormat(startDate)) {
            console.log("Invalid startDate:", startDate);
            return false; // Invalid startDate
        }
        if (endDate && !isValidDateFormat(endDate)) {
            console.log("Invalid endDate:", endDate);
            return false; // Invalid endDate
        }
        return true; // Parameters are valid
    };

    //The function `handleTabs` sets the value of `tabs` to the provided `item` which it the selected tab.
    const handleTabs=(item)=>{
        settabs(item)
        let newSearchParams = Object.fromEntries(searchParams);
        newSearchParams.tab_name = item;
        newSearchParams.std_id = studentDetails?.student_id
        newSearchParams.std_uuid = studentDetails?._id;
        newSearchParams.ay_id = studentDetails?.academic_year?.academic_year_id,
        newSearchParams.class_id = studentDetails?.classes?.class_id
        newSearchParams.sec_id = studentDetails?.sections?.section_id
        delete newSearchParams.dropdown
        setSearchParams(newSearchParams)
    }

    /**
     * The function `getStudentData` retrieves financial year data, sets dropdown options and current
     * financial year, and fetches student details and invoice details based on search parameters.
     */
    const getStudentData = async()=>{
        try {
            let res = await dataService.GetAPI(`students/${id}?status=true`, true);
            const studentData = res?.data?.data?.data || {};
            setStudentDetails(studentData);
            setStudentInvoiceDetails(res?.data?.data)//one less data cause everything not related to inovices is inside that data
            return studentData;
        } catch (error) {
            navigate("/404");
            throw error;
        }
    }

    const handleSendInvite = async (type) => {
        try {
            if (type === "father") {
                setFatherInviteLoading(true)
            } else if (type === "mother") {
                setMotherInviteLoading(true)
            }

            const branch_id = await GetBranchId()

            const payload = {
                data: {
                    branch_id: branch_id,
                    student_id: studentDetails?._id || id,
                    invite_type: type,
                },
            }

            const response = await dataService.PostAPI(payload, "students/send-invite")

            setStudentDetails((prv) => ({
                ...prv,
                ...(type === "father" ? { is_father_invite_sent: true } : { is_mother_invite_sent: true })
            }))

            setToastmessage(
                (type === "father" ? studentDetails?.is_father_invite_sent : studentDetails?.is_mother_invite_sent)
                    ? "Invite resent successfully"
                    : response?.data?.data?.message || "Invite sent successfully"
            )
        } catch (error) {
            setToastErrorMessage(error?.response?.data?.message || "Failed to send invite")
        } finally {
            setFatherInviteLoading(false)
            setMotherInviteLoading(false)
        }
    }

    const parentInviteList = [
        studentDetails?.is_father_details && {
            type: "father",
            name: `${studentDetails?.father_details?.first_name || ""} ${studentDetails?.father_details?.last_name || ""}`.trim() || "Father",
            email: studentDetails?.father_details?.email_address || "-",
            buttonLabel: studentDetails?.is_father_invite_sent ? "Resend Invite" : "Send Invite"
        },
        studentDetails?.is_mother_details && {
            type: "mother",
            name: `${studentDetails?.mother_details?.first_name || ""} ${studentDetails?.mother_details?.last_name || ""}`.trim() || "Mother",
            email: studentDetails?.mother_details?.email_address || "-",
            buttonLabel: studentDetails?.is_mother_invite_sent ? "Resend Invite" : "Send Invite"
        }
    ].filter(Boolean)

    const [invoicesData, setInvoicesData] = useState({})
    const getInvoices = async()=>{
        try {
            const branch_id = await GetBranchId()
            let endpoint = `financial-years?branch_id=${branch_id}&filter=true&status=open,closed,ongoing&sort=start_date%2Bdesc`;
            const response = await dataService.GetAPI(endpoint, true)
            const temp1 = response?.data?.data?.financial_years
            const temp2 = response?.data?.data?.ongoing
            setFinancialYearsDropdownOptions(temp1)
            const selectedFY = JSON.parse(localStorage.getItem('FY_details'));
            const ongoingFY = temp1?.find((fy) => fy.name === selectedFY.name);
            setCurrentFinacialYear(ongoingFY.name)

            if (ongoingFY) {
                setStartDate(searchParams?.get('start_date') !== null ? searchParams?.get('start_date') : ongoingFY.start_date.substring(0, 10));
                setEndDate(searchParams?.get('end_date') !== null ? searchParams?.get('end_date') : ongoingFY.end_date.substring(0, 10));
            }
            const snakeCaseInvoiceStatus = invoiceStatus.replace(/\s+/g, '_').toLowerCase();
            let res = await dataService.GetAPI(`students/view-student-invoice/${id}?start_date=${
                searchParams?.get('start_date') !== null ? searchParams?.get('start_date') : ongoingFY.start_date.substring(0, 10)}&end_date=${
                searchParams?.get('end_date') !== null ? searchParams?.get('end_date') : ongoingFY.end_date.substring(0, 10)}&invoice_status=${
                searchParams?.get('invoice_stauts') !== null ? searchParams?.get('invoice_stauts').replace(/\s+/g, '_').toLowerCase() :snakeCaseInvoiceStatus}&status=true`);
            setInvoicesData(res?.data?.data)
            setStartDateDisplay(searchParams?.get('start_date') !== null ? searchParams?.get('start_date') : ongoingFY.start_date.substring(0, 10));
            setEndDateDisplay(searchParams?.get('end_date') !== null ? searchParams?.get('end_date') : ongoingFY.end_date.substring(0, 10))

        } catch (error) {
            navigate("/404");
            throw error;
        } finally {
            setApiIsLoading(false)
        }
    }

    //The function `getAcademicYears` makes an asynchronous API call to retrieve academic years data and sets the dropdown options with the response data.
    const getAcademicYears = async(studentRecordId) => {
        const currentStudentId = studentRecordId || studentDetails?._id;
        if (!currentStudentId) return;
        const branch_id = await GetBranchId()
        let endpoint = `academic-years?branch_id=${branch_id}&filter=true&status=ongoing,upcoming,completed`;
        const response = await dataService.GetAPI(endpoint, true)
        const mainAYList = response?.data?.data?.data || [];

        let endpoint1 = `students/list-ay-class?branch_id=${branch_id}&student_id=${currentStudentId}`;
        const response1 = await dataService.GetAPI(endpoint1);

        const studentAyList = response1?.data?.data?.data || [];
        let filteredList = [];

        studentAyList.forEach((studentAY) => {
            if (studentAY.latest) {
                const foundAY = mainAYList.find(ay => ay._id === studentAY.academic_year_id);
                if (foundAY) {
                    filteredList.unshift(foundAY); // Add at 0 element
                }
            } else {
                const foundAY = mainAYList.find(ay => ay._id === studentAY.academic_year_id);
                if (foundAY) {
                    filteredList.push(foundAY); 
                }
            }
        });

        setAcademicYearsDropdownOptions(filteredList)
    }

    const loadViewData = async () => {
        setViewLoading(true);
        setStudentDetails({});
        setStudentInvoiceDetails([]);
        setInvoicesData({});
        setAcademicYearsDropdownOptions({});
        try {
            const [studentData] = await Promise.all([
                getStudentData(),
                getInvoices(),
            ]);
            await getAcademicYears(studentData?._id);
        } finally {
            setViewLoading(false);
        }
    }


    /* The above code is a React useEffect hook that runs when the component mounts. It first calls the
    `getStudentData` function. Then, it retrieves query parameters from the URL using the
    `URLSearchParams` object. It assigns the values of the query parameters to variables such as
    `tabName`, `dateRange`, `invoiceStatus`, `startDate`, and `endDate`. */
    useEffect(()=>{
        loadViewData();
        //Access other query parameters from the URL
        const queryParams = new URLSearchParams(window.location.search);
        const tabName = queryParams.get('tab_name');
        const dateRange = queryParams.get('date_range');
        const invoiceStatus = queryParams.get('invoice_status');
        const startDate = queryParams.get('start_date');
        const endDate = queryParams.get('end_date');

        // Validate parameters on page load
        const isValid = validateParameters(tabName, dateRange, invoiceStatus, startDate, endDate);

        if (!isValid) {
            setIsParamsValid(false)
            navigate('/404')
        }
    },[id])

    const handleStatus = (key) => {
        let val = {}
        switch (studentDetails?.status) {
        case "active":
            val = {status : "Active", img: "successDot.svg", color : "bg-[#C5FFD5]", icon:''}
            break;
        case "transferred":
            val = {status : "Transferred", img: "bluedot.svg", color : "bg-[#C2DCEF]", icon: "transferred"}
            break;
        case "terminated":
            val = {status :"Terminated", img: "redDot.svg", color : "bg-[#FFD6D3]", icon: "terminated"}
            break;
        
        default:
            break;
        }
        return val[key];
    }

    /* The code is creating a current date object using the `Date` constructor. */
    const currentDate = new Date();
    const options = { year: 'numeric', month: 'short', day: '2-digit' };
    const formattedDate = currentDate.toLocaleDateString('en-US', options);

    const handleDottedDropDown = () => {
        setDottedDropDown(!dottedDropDown)
    }

    const handleTerminateStudent = (studentID, studentRecordID,studentPendingFee, studentFullName) => {
        setStudentDataToTerminate({
            studentName: studentFullName || studentDetails?.full_name || '',
            studentID: studentID,
            studentRecordID:studentRecordID
        })
        if(studentPendingFee > 0) {
            setIsOutStandingFee(true)
        } else {
            setApproveTriminate(true)
        }
    }

    const handelTerminateApproveButton = async() => {
        const branch_id = await GetBranchId()
        setViewLoading(true)
        setApproveTriminate(false)
        try {
            let body = {
                branch_id : branch_id,
                // student_full_name: studentDataToTerminate.studentName,
                student_id: studentDataToTerminate?.studentID, 
            }
            const response = await dataService.PostAPI(body,`students/terminate` );
            setToastmessage(response?.data?.data?.message)
        } catch (error) {
            console.log(error)
            setViewLoading(false);
            setApproveTriminate(false)
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
        } finally {
            setViewLoading(false);
            let params = Object.fromEntries(searchParams);
            params['status'] = 'terminated,transferred';
            params['page_number']='1';
            setSearchParams({ ...params})
            setRefreshKey(true);
        }
    }
    const handleNavigateToIssueInventory = (data) => {
        const params = new URLSearchParams({
            student_name: data?.full_name || "",
            student_id: data?.student_id || "",
            student_uuid: data?._id || "",
            academic_year_name: data?.academic_year?.name || "",
            academic_year_id: data?.academic_year?.academic_year_id || "",
            academic_start: data?.academic_year.start_date,
            academic_end: data?.academic_year.end_date,
            class: data?.classes?.class_name || "",
            class_id: data?.classes?.class_id || "",
            sections: data?.sections?.section_name || "",
            section_id: data?.sections?.section_id || "",
            doa: data?.date_of_admission || "",
            isFromDirectory: true,
            redirect_url: `/student-master/directory/${id}?${searchParams.toString()}`
        });
      
        navigate(`/student-master/invoice-list/issue-inventory?${params.toString()}`);
    };

    useEffect(() => {
        if(refreshKey){
            getStudentData();
        }
    }, [refreshKey]);

    return (
        <CardHeader noPadding>
            <div
                className="mainDataCntnrTop shadow-s13"
                style={{ position: "sticky", position: "-webkit-sticky"}}
            >
                <div className="flex items-center" >
                    <div className="flex cursor-pointer" 
                        onClick={()=>{
                            navigate(`/student-master/directory?page_number=${searchParams.get('page_number') || '1'}&limit=${searchParams.get('limit') || '10'}${searchParams.get('search') ? `&search=${searchParams.get('search')}` : ''}${searchParams.get('filter') ? `&filter=${searchParams.get('filter')}` : ''}${searchParams.get('academic_year') ? `&academic_year=${searchParams.get('academic_year')}` : ''}${searchParams.get('class_') ? `&class_=${searchParams.get('class_')}` : ''}${searchParams.get('section_') ? `&section_=${searchParams.get('section_')}` : ''}${searchParams.get('status') ? `&status=${searchParams.get('status')}` : ''}`);
                        }} >
                        <img src="/images/back-btnBlue.svg" alt="icon" loading="lazy" />
                    </div>
                    <h5 class=" pageHeader ml-2.5 adderror">
                        Student Dashboard
                    </h5>
                </div>
                
                {!isInactiveBranch && <div className="flex items-center">
                    <button
                        className={`view-actn-btn ${studentInvoiceDetails?.data?.status && studentInvoiceDetails?.data?.status !== 'active' ? 'disabled' : ''}`}
                        onClick={(e) => {
                            if (viewLoading || studentInvoiceDetails?.data?.status !== 'active') {
                                e.preventDefault();
                            } else {
                                navigate(`/student-master/directory/edit-student/${id}?${searchParams.toString()}`, { state: { redirect: 'fromViewScreen' } })
                            }
                        }
                        }
                    >
                        Edit
                    </button>

                    <button className="view-actn-btn"
                        onClick={() => {handleNavigateToIssueInventory(studentDetails)}}
                        
                    >
                        Issue Invoice
                    </button>
                    <button className="view-actn-btn"
                        onClick={() => {
                            if (!viewLoading && studentInvoiceDetails?.data?.status === 'active') {
                                if (invoicesData?.total_invoices === 0 || Number(invoicesData?.total_due?.toFixed(2)) === 0) {
                                    setToastErrorMessage(`No outstanding Invoices available for the student`);//Change this message to Dialog box with OK button (Refer GRN Invoice # exists dialogue)-Anitha
                                } else {
                                    navigate(`/student-master/collect-fee/collect-fee-invoice/${id}`)
                                }
                            }
                        }}
                        disabled={studentInvoiceDetails?.data?.status && studentInvoiceDetails?.data?.status !== 'active'}
                    >
                        Collect Fee
                    </button>
                    {(
                        <button
                            type="button"
                            className="view-actn-btn"
                            onClick={() => setShowParentInvitePopup(true)}
                            disabled={studentInvoiceDetails?.data?.status && studentInvoiceDetails?.data?.status !== 'active'}
                        >
                            Send Invitation(s)
                        </button>
                    )} 
                    <button
                        type="button"
                        className={`more_actn_btn-blue ${studentInvoiceDetails?.data?.status && studentInvoiceDetails?.data?.status !== 'active' ? 'disabled' : ''}`}
                        id="three_dotted"
                        disabled={studentInvoiceDetails?.data?.status && studentInvoiceDetails?.data?.status !== 'active'}
                        onClick={() => {
                            handleDottedDropDown()
                        }}
                    ><img src="/images/blue-three-dots.svg" alt="" /></button>
                    {dottedDropDown && !viewLoading && <div class="relative" ref={threeDottedRef}>
                        <ul className='three_dot_btn_drp_dwn wid2 top1 shadow-s1'>
                            <li>
                                <AnimatedButton
                                    handleClick={() => {
                                        setIsFutureTermsModel(true);
                                        setDottedDropDown(!dottedDropDown)
                                    }}
                                    buttonName={"Future Terms"}
                                    id="view_future_term"
                                    className="w-full text-left px-3 cursor-pointer  font-normal text-[#031624] hover:text-[#106EB4]" />
                            </li>
                            <li class="lst_sprtr"></li>
                            <li>
                                <AnimatedButton
                                    handleClick={() => {
                                        handleTerminateStudent(id,studentDetails?.student_id, invoicesData?.total_due, studentDetails?.full_name)
                                        setDottedDropDown(!dottedDropDown)
                                    }}
                                    buttonName={"Terminate Student"}
                                    className="w-full text-left px-3 cursor-pointer  font-normal text-[#031624] hover:text-[#106EB4] mt-1.5" />
                            </li>
                        </ul>
                    </div>
                    }
                </div>
                }
                
                {toastErrorMessage !== "" && (
                    <Toast
                        message={toastErrorMessage}
                        type="error"
                        setToastmessage={setToastErrorMessage}
                    />
                )}
            </div>
            {viewLoading?<Skeleton/>:<>
                <div class="relative">
                    <div class="flex justify-between items-baseline p-2 rounded-sm border border-[#c2dcef] bg-[#eef7fe] leading-6 mx-10 mt-5">
                        <div class="flex items-baseline w-full">
                            <div class="text-left max-w-[75%] items-baseline" style={{'min-width':'25%'}}>
                                <p class="more-lines text-lg font-semibold flex items-baseline" title={studentDetails?.full_name}>
                                    <span>{studentDetails?.full_name}</span>
                                    <span className={`w-fit rounded ${handleStatus("color")} flex items-center justify-center py-1 px-2.5 ml-3`}>
                                        <img loading="lazy" decoding="async" src={`/images/${handleStatus("img")}`} alt="icon" />
                                        <span class="text-f7 font-normal text-[#031624] pl-1">{handleStatus("status")}</span>
                                    </span>
                                </p>    
                                <p>{studentDetails?.student_id}</p>
                            </div>
                            <div class="ml-[30px] w-[25%] flex-col">
                                <p >{studentDetails?.academic_year?.name || "No AY Details"}</p>
                                <p >{studentDetails?.classes?.class_name || ""}, {studentDetails?.sections?.section_name || ""}</p>
                            </div>
                        </div>
                        <div class="ml-[20px] text-right w-[43%]">
                            <p >Total Outstanding Fee as on {formattedDate}</p>
                            <a class="text-f7 font-normal text-[#106EB4] inline-flex cursor-pointer" onClick={() => handleTabs('Student Statement')}>
                                {invoicesData?.total_due?.toFixed(2) || '00.00'}
                            </a>
                        </div>
                    </div>
                    <div class=" mx-10 mt-[5px]">
                        <ul
                            class={`flex list-none flex-row border border-[#e7e7e7] justify-between  pt-[10px] z-30 top-[70px] sticky bg-[#fff] px-3`}
                            role="tablist"
                        >
                            {tabArray.map((item) => (
                                <li role="presentation" key={item} className="text-center">
                                    <p
                                        onClick={() => handleTabs(item)}
                                        key={item}
                                        id ={item !== "Student Statement" ? item : 'View-student-statements'}
                                        className={`tab-element ${
                                            tabs === item
                                                ? "selected"
                                                : ""
                                        }   `}
                                    >
                                        {item !== "Academic Reports" && item !== "Student Statement"
                                            ? `${item} Details`
                                            : `${item}`}
                                    </p>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div class="scroll-bar tabbedPgListDiv student"> 
                        {tabs === "Basic" && (
                            <div className="pl-6 pr-1">
                                <div className="relative pr-5">
                                    <BasicDetails studentDetails={studentDetails} />
                                </div>
                            </div>
                        )}
                        {tabs === "Contact" && (
                            <div className="pl-6 pr-1 ">
                                <div className="relative pr-5">
                                    <ContactDetails studentDetails={studentDetails} />
                                </div>
                            </div>
                        )}
                        {tabs === "Academic" && (
                            <div className="pl-6 pr-1">
                                <div className="relative pr-5">
                                    <AcademicDetails studentDetails={studentDetails} />
                                </div>
                            </div>                            
                        )}
                        {tabs === "Student Statement" && (
                            <StudentStatement studentDetails={studentDetails} tabs={tabs} setSearchParams={setSearchParams} setApiIsLoading={setApiIsLoading}
                                startDate={startDate} endDate={endDate} financialYearsDropdownOptions={financialYearsDropdownOptions} 
                                setStartDate={setStartDate} setEndDate={setEndDate} setInvoiceStatus={setInvoiceStatus} apiIsLoading={apiIsLoading}
                                currentFinacialYear={currentFinacialYear} searchParams={searchParams} toastErrorMessage={toastErrorMessage}
                                getStudentData={getInvoices} studentInvoiceDetails={invoicesData} setToastErrorMessage={setToastErrorMessage}
                                setAcademicYearsDropdownOptions={setAcademicYearsDropdownOptions} academicYearsDropdownOptions={academicYearsDropdownOptions}
                                setStartDateDisplay={setStartDateDisplay} setEndDateDisplay={setEndDateDisplay} startDateDisplay={startDateDisplay} endDateDisplay={endDateDisplay}
                            />
                        )}
                        {tabs === "Academic Reports"  && (
                            <AcademicReports tabs={tabs} studentDetails={studentDetails} searchParams={searchParams} 
                                setSearchParams={setSearchParams} setToastErrorMessage={setToastErrorMessage} 
                            />
                        )}
                        {tabs === "Attendance" && (
                            <AttendanceReports tabs={tabs} studentDetails={studentDetails} searchParams={searchParams} 
                                setSearchParams={setSearchParams} setToastErrorMessage={setToastErrorMessage} 
                            />
                        )}
                    </div>
                </div>
                {showParentInvitePopup && (
                    <ParentInvitePopup
                        parentInviteList={parentInviteList}
                        handleClose={() => setShowParentInvitePopup(false)}
                        handleSendInvite={handleSendInvite}
                        fatherInviteLoading={fatherInviteLoading}
                        motherInviteLoading={motherInviteLoading}
                    />
                )}
            </>}
            {isFutureTermsModel && <FutureTermsModel handleClose={() => setIsFutureTermsModel(false)} studentDetails={studentDetails}/>}
            {approveTriminate &&
                <AnimatedModel
                    Children={
                        <ConfirmationPrompt
                            handleOnCLickActivate={handelTerminateApproveButton}
                            handleClose={() => { setApproveTriminate(false) }}
                            tittle={`Terminate Student`}
                            dialogueWidth={'400px'}
                            message={`Are you sure you want to terminate the student '${studentDataToTerminate.studentName}' ?`}
                            buttonName={`Terminate`}
                            loadingActivation={loadingButton}
                        />
                    }
                />
            }
            {isOutstandingFee &&
                <AnimatedModel
                    Children={
                        <ConfirmationModel
                            handleOnCLickActivate={()=>{setIsOutStandingFee(false) }}
                            handleClose={() => { setIsOutStandingFee(false) }}
                            dialogueWidth={'580px'}
                            message={<>Student cannot be terminated due to pending fees. <br/>
                                To proceed, use the &#39;Collect Fee&#39; option and clear the outstanding invoices.</>}
                            buttonName={`OK`}
                            loadingActivation={loadingButton}
                        />
                    }
                />
            }
        </CardHeader> 
    );
};

export default ViewStudent;
